import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-resend-verification-dialog',
  templateUrl: './resend-verification-dialog.component.html',
  styleUrls: ['./resend-verification-dialog.component.css']
})
export class ResendVerificationDialogComponent {
  resendForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ResendVerificationDialogComponent>
  ) {
    this.resendForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit() {
    console.log(this.resendForm, 'resendForm');
    if (this.resendForm.valid) {
      this.dialogRef.close(this.resendForm.value.email);
    }
  }

  onCancel() {
    console.log('onCancel');
    this.dialogRef.close();
  }
} 